import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { format } from 'date-fns';
import { AuthService, Availability, CartService, MetadataService, Product, SelectedCustomerService } from 'gung-standard';
import { filter, first, forkJoin, of, switchMap } from 'rxjs';

@Component({
    selector: 'otto-olsen-barcode-scanner-error-modal',
    templateUrl: './otto-olsen-barcode-scanner-error-modal.component.html',
    styleUrl: './otto-olsen-barcode-scanner-error-modal.component.scss',
    standalone: false
})
export class OttoOlsenBarcodeScannerErrorModalComponent implements OnInit {
  @Input()
  public qtyToAdd: number;

  @Input()
  public currentQty: number;

  @Input()
  public currentStock: number;

  @Input()
  public unit: string = 'stk';

  @Input()
  public availability: Availability;

  @Input()
  public product: Product;

  @Input()
  public endOfLife: boolean;

  public isSales = false;

  uncertainPriceItemBought: { customerName: string, quantity: number, unitType: string, deliveryDate: string };

  constructor(
    public activeModal: NgbActiveModal,
    protected authService: AuthService,
    protected cartService: CartService,
    protected http: HttpClient,
    protected selectedCustomerService: SelectedCustomerService,
    protected metadataService: MetadataService
  ) {
    this.authService.getRoles().pipe(filter(roles => !roles), first()).subscribe(roles => this.isSales = roles.indexOf('SALES') > -1);
  }

  ngOnInit(): void {
    if (this.product.extra?.ar?.itemtypecd1 === 0 || this.product.extra?.ar?.itemtypecd1 === 7) {
      this.selectedCustomerService.getSelectedCustomer().pipe(
        first(),
        switchMap(customer => forkJoin({
          customer: of(customer),
          existingOrders: this.http.get<{ quantity: number, unitCode: string, deliveryDate: string }[]>(`otto/existing-orders?customerId=${customer.id}&productId=${this.product.id}`).pipe(first())
        }))
      ).subscribe(({ customer, existingOrders }) => {
        if (existingOrders.length > 0) {
          const earliestOrder = existingOrders.reduce((earliest, current) => {
            return new Date(current.deliveryDate) < new Date(earliest.deliveryDate) ? current : earliest;
          });

          this.uncertainPriceItemBought = {
            customerName: customer.name,
            quantity: earliestOrder.quantity,
            unitType: this.metadataService.getMetadataValue('xen', 'enhetskodbeskr', this.product.extra?.ar?.enhetskod),
            deliveryDate: format(new Date(earliestOrder.deliveryDate), 'dd/MM/yyyy')
          };
        }
      });
    }
  }

  reduceStock() {
    this.cartService.setProductQuantity(this.product.id, this.currentStock);
    this.activeModal.close(this.currentStock);
  }

  delete() {
    this.cartService.setProductQuantity(this.product.id, 0);
    this.activeModal.close(0);
  }

  keepQuantiy() {
    this.cartService.setProductQuantity(this.product.id, this.currentQty + this.qtyToAdd);
    this.activeModal.close(this.currentQty + this.qtyToAdd);
  }
}
